const CountryFlagImage = ({ country }) => {
	return (
		<img
			src={`https://flagcdn.com/16x12/${country.code.toLowerCase()}.png`}
			alt={country.name}
			onError={(e) =>
				(e.target.src = `https://www.countryflags.io/${country.code.toLowerCase()}/flat/16.png`)
			}
			style={{ height: 10 }}
		/>
	);
};

export default CountryFlagImage;
